<template>
  <div>
    <div class="elasticBlockStoreResource-title">
      <div>{{ $t("RAM.AWS.ElasticBlockStorage.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:elasticBlockStoreResource:update'
          ]"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          :loading="modal_loading"
          @click="exportList"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:elasticBlockStoreResource:export'
          ]"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="elasticBlockStoreResource-top">
      <elastic-block-store-resource-search
        ref="elasticBlockStoreResourceSearchChild"
      ></elastic-block-store-resource-search>
    </div>
    <table-elastic-block-store-resource></table-elastic-block-store-resource>
  </div>
</template>

<script>
import ElasticBlockStoreResourceSearch from "../ebs/ElasticBlockStoreResourceSearch";
import TableElasticBlockStoreResource from "../ebs/TableElasticBlockStoreResource";

export default {
  name: "ElasticBlockStoreResource",
  components: {
    ElasticBlockStoreResourceSearch,
    TableElasticBlockStoreResource
  },
  data() {
    return {
      modal_loading: false,
      accountNameSearchID: "",
      companyId: ""
    };
  },
  methods: {
    update: function() {
      this.companyId = this.$refs.elasticBlockStoreResourceSearchChild.companyId;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 3,
          accountType: 0
        })
        .then(res => {
          setTimeout(() => {
            this.$Message.success(this.$t('common.updateSuccess'));
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      console.log(this.$refs);
      // 获取子组件数据
      this.accountNameSearchID = this.$refs.elasticBlockStoreResourceSearchChild.accountName;
      this.companyId = this.$refs.elasticBlockStoreResourceSearchChild.companyId;

      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportVolume({
          accountName: this.accountNameSearchID,
          companyId: this.companyId
        })
        .then(res => {
          let fileName = this.$t('RAM.export.elasticBlockStorage');
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success(this.$t('common.exportSuccess'));
        });
    }
  }
};
</script>

<style scoped>
.elasticBlockStoreResource-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.elasticBlockStoreResource-title > div:nth-child(1) {
  float: left;
}
.elasticBlockStoreResource-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.elasticBlockStoreResource-top {
  width: 100%;
  height: 53px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/ebs/ElasticBlockStoreResource.vue